<template>
  <div>
    <VCard title="SMS Template 🙌">
      <VCardText>Coming Soon</VCardText>
    </VCard>
  </div>
</template>

<script setup>
definePage({
  meta: {
    name: 'app-global-template-sms',
  },  
})
</script>
